import { render } from "./LiveChat.vue?vue&type=template&id=1e2a3dcb&scoped=true"
import script from "./LiveChat.vue?vue&type=script&lang=js"
export * from "./LiveChat.vue?vue&type=script&lang=js"

import "./LiveChat.vue?vue&type=style&index=0&id=1e2a3dcb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2a3dcb"]])

export default __exports__